/*
 * Customers and suppliers share ~90% of their screens (list, form modal,
 * detail). This config captures the differences (inventory §3 & §4) so a single
 * set of components serves both:
 *   - customers: payment terms + preferred language + delivery addresses;
 *     Peppol "not found" badge is amber.
 *   - suppliers: no payment terms / language, read-only bank accounts, no
 *     delivery addresses; Peppol "not found" badge is red.
 */
export const PARTY_CONFIG = {
  customers: {
    key: 'customers',
    endpoint: '/customers',
    arrayKey: 'customers',
    invoiceParam: 'customer_id',
    hasPaymentTerms: true,
    hasLanguage: true,
    hasDeliveryAddresses: true,
    hasBankAccounts: false,
    peppolNotFoundTone: 'warning',
  },
  suppliers: {
    key: 'suppliers',
    endpoint: '/suppliers',
    arrayKey: 'suppliers',
    invoiceParam: 'supplier_id',
    hasPaymentTerms: false,
    hasLanguage: false,
    hasDeliveryAddresses: false,
    hasBankAccounts: true,
    peppolNotFoundTone: 'danger',
  },
}
